//@flow
import { Formik } from 'formik';
import _ from 'lodash';
import Papa from 'papaparse';
import React from 'react';
import connect from 'react-redux/es/connect/connect';
import * as Yup from 'yup';

import Switch from 'react-switch';
import CpfInput from '../../components/Inputs/CpfInput';
import FormInput from '../../components/Inputs/FormInput';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import SelectInput from '../../components/Inputs/SelectInput';
import Toast from '../../components/Toasts/Toast';
import { isValidCPF } from '../../components/Utils/cpfUtils';
import { objectsConstants } from '../../constants/objects.constants';
import { mapApiError } from '../../helpers/error-mapper';
import {
  isAdmin,
  isAdminBio,
  isAprovador,
  isPontoAtendimento,
  isSolicitante,
  isSudo,
} from '../../helpers/permissions.helper';
import { clienteService } from '../../services/cliente.service';
import { importarPedidoService } from '../../services/importarPedido.service';
import { pedidosService } from '../../services/pedidos.service';
import { pontoAtendimentoService } from '../../services/pontoAtendimento.service';
import { userService } from '../../services/user.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';

const buildValidationSchema = (isSudoFlag, isPontoFlag) => {
  return Yup.object().shape({
    cliente: isSudoFlag
      ? Yup.object()
          .required('Cliente é obrigatório')
          .nullable()
      : Yup.mixed().nullable(),

    pontoAtendimentoId: isPontoFlag
      ? Yup.mixed().nullable()
      : Yup.string()
          .required('PA é obrigatório')
          .nullable(),
    nomePaciente: Yup.string().when('grupoPedido', {
      is: (val) => val === 'JUDICIAL' || val === 'DOMICILIAR',
      then: Yup.string().required('Obrigatório'),
      otherwise: Yup.string().nullable(),
    }),
    cpfPaciente: Yup.string().when('grupoPedido', {
      is: (val) => val === 'JUDICIAL' || val === 'DOMICILIAR',
      then: Yup.string()
        .required('Obrigatório')
        .test('cpf-valido', 'CPF inválido', (value) => {
          if (!value) return false;
          return isValidCPF(String(value).trim());
        }),
      otherwise: Yup.string()
        .nullable()
        .notRequired()
        .test('cpf-valido-opcional', 'CPF inválido', (value) => {
          if (!value || String(value).trim() === '') return true; // deixa em branco passar
          return isValidCPF(String(value).trim());
        }),
    }),

    tipoPedido: Yup.string().required('Tipo de pedido é obrigatório'),
    grupoPedido: Yup.string()
      .nullable()
      .required('Grupo do pedido é obrigatório'),
    produtos: Yup.array()
      .of(
        Yup.object().shape({
          produto: Yup.object()
            .shape({
              codigoProduto: Yup.string().nullable(),
              descricao: Yup.string().nullable(),
            })
            .nullable(),

          codigoProduto: Yup.string()
            .required('Código do produto é obrigatório')
            .nullable(),

          qtdSolicitar: Yup.number()
            .typeError('Quantidade inválida')
            .required('Obrigatório')
            .test(
              'estoque-suficiente',
              'Quantidade solicitada ultrapassa o estoque disponível',
              function(value) {
                const { estoqueTotal } = this.parent;
                if (estoqueTotal == null || isNaN(estoqueTotal)) return true;
                return value <= estoqueTotal;
              },
            ),

          estoqueTotal: Yup.number().nullable(), // garantir que existe no objeto
        }),
      )
      .min(1, 'É necessário importar ao menos um produto'),
  });
};

class ImportarPedidoEdit extends React.PureComponent {
  constructor(props) {
    super(props);
    const user = userService.getCurrentUser();
    this.formikRef = React.createRef();

    this.state = {
      entity: {
        cliente: isSudo() ? null : user.cliente,
        pontoAtendimentoId: isPontoAtendimento()
          ? (user.pontoAtendimento && user.pontoAtendimento.id) || null
          : null,
        tipoPedido: '',
        grupoPedido: null,
        observacoes: '',
        produtos: [],
      },
      atualizou: true,
    };
  }

  componentDidMount() {
    const user = userService.getCurrentUser();
    const id = _.get(this.props.match, 'params.id');

    if (id) {
      this.props.loading(true);
      importarPedidoService.doGet(id).then(async (response) => {
        const pedido = response.data;
        if (!pedido) return;

        const produtos = (pedido.produtos || []).map((item) => {
          return {
            produto: item.produto,
            codigoOmni: item.produto && item.produto.codigoOmni,
            codigoProduto: item.codigoProduto,
            qtdSolicitar: parseInt(item.qtdSolicitar, 10) || 0,
            idProduto: item.produto && item.produto.id,
            descricao: item.produto && item.produto.descricao,
          };
        });

        const entityAtualizada = {
          id: pedido.id,
          cliente: pedido.cliente || (isSudo() ? null : user.cliente),
          pontoAtendimentoId: pedido.pontoAtendimentoId,
          produtos,
          urgente: pedido.urgente || false,
          justificativaRecusa: pedido.justificativaRecusa,
          tipoPedido: pedido.tipoPedido,
          grupoPedido: pedido.grupoPedido || null,
          cpfPaciente: pedido.cpfPaciente,
          nomePaciente: pedido.nomePaciente,
        };

        this.setState(
          {
            entity: entityAtualizada,
            atualizou: true,
          },
          async () => {
            this.props.loading(false);
          },
        );
      });
    } else {
      this.setState({ atualizou: true });
    }
  }

  verificarEstoqueProdutosAsync = async (produtos, setFieldValue) => {
    this.props.loading(true);

    if (isPontoAtendimento()) {
      const atualizados = produtos.map((item) => ({
        ...item,
        temEstoque: true,
        estoqueTotal: null,
      }));
      setFieldValue('produtos', atualizados);
      this.props.loading(false);
      return;
    }

    try {
      const payload = produtos
        .filter((p) => p.codigoProduto && p.qtdSolicitar > 0)
        .map((p) => ({
          codigoProduto: p.codigoProduto,
          qtdSolicitar: p.qtdSolicitar,
        }));

      const response = await pedidosService.verificarEstoqueLote(payload);
      const estoqueMap = _.keyBy(response.data, 'idProduto');

      const produtosFinal = produtos.map((item) => {
        const estoqueInfo = estoqueMap[item.codigoProduto] || {
          estoqueTotal: 0,
          temEstoque: false,
        };

        return {
          ...item,
          qtdSolicitar: Math.min(item.qtdSolicitar, estoqueInfo.estoqueTotal),
          estoqueTotal: estoqueInfo.estoqueTotal,
          observacoes: null,
          dataValidade: null,
        };
      });

      setFieldValue('produtos', produtosFinal);
      this.setState({ estoquePorProduto: estoqueMap });
    } catch (error) {
      console.error('Erro ao verificar estoque em lote:', error);
      this.props.error({ message: 'Erro ao verificar estoque' });
    } finally {
      this.props.loading(false);
    }
  };

  handleCSVUpload = (event, setFieldValue) => {
    const file = event.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (res) => {
        this.processarCSVResultado(res, setFieldValue);
      },
    });
  };

  processarCSVResultado = async (res, setFieldValue) => {
    if (res.errors.length) {
      this.props.error({ message: 'Erro ao processar CSV.' });
      return;
    }

    const produtos = res.data
      .map((row) => ({
        codigoProduto: row.codigoProduto && row.codigoProduto.trim(),
        produto: {
          codigoProduto: row.codigoProduto && row.codigoProduto.trim(),
          descricao: row.descricao && row.descricao.trim(),
        },
        descricao: row.descricao && row.descricao.trim(),
        qtdSolicitar: Number(row.quantidade || 0),
      }))
      .filter((p) => p.codigoProduto && p.qtdSolicitar > 0);

    await this.verificarEstoqueProdutosAsync(produtos, setFieldValue);
  };

  render() {
    const { entity } = this.state;
    const isSudoFlag = isSudo();
    const isPontoFlag = isPontoAtendimento();
    const validationSchema = buildValidationSchema(isSudoFlag, isPontoFlag);

    // const isFinalizado =
    //   (entity.status === 'APROVADO' || entity.status === 'RECUSADO') &&
    //   !isSudo();

    const isFinalizado = entity.id != null;

    return (
      <React.Fragment>
        <TopoTitleComponente mainTitle="Importar Pedido CSV" canBack />
        <Formik
          validationSchema={validationSchema}
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={entity}
          enableReinitialize
          innerRef={this.formikRef}
          onSubmit={async (values, actions) => {
            console.log(JSON.stringify(values.produtos));
            this.props.loading(true);
            try {
              if (!values.grupoPedido) {
                this.props.error({ message: 'Informe o grupo do pedido.' });
                this.props.loading(false);
                actions.setSubmitting(false);
                return;
              }
              await importarPedidoService.doSave(values);
              this.props.success({
                message: 'Pedido importado salvo com sucesso',
              });
              this.props.history.push('/importarPedido');
            } catch (e) {
              const friendly = mapApiError(e);
              this.props.error({
                message: `${friendly.title}: ${friendly.message}`,
              });
            } finally {
              this.props.loading(false);
            }
          }}
        >
          {(formikProps) => {
            this.formikRef.current = formikProps;

            const {
              values,
              errors,
              touched,
              handleChange,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            } = formikProps;

            return (
              <form onSubmit={handleSubmit} noValidate>
                <Toast />
                <div className="cardSeculus">
                  <div className="form-row">
                    {(isSudo() || isAdminBio()) && (
                      <div className="form-group col-6 col-lg-6">
                        {!this.state.viewMode && (
                          <FormSelectInput
                            name="cliente"
                            id={'cliente'}
                            label="Cliente"
                            placeholder="Selecione o cliente"
                            valueKey="id"
                            labelKey="label"
                            noSize={true}
                            required={false}
                            returnFullObject={true}
                            isMulti={false}
                            searchable={false}
                            allowSelectAll={false}
                            service={clienteService.findAll}
                            onChange={(name, value) => {
                              console.log(value);

                              setFieldValue(name, value);
                            }}
                            value={values.cliente}
                          />
                        )}
                      </div>
                    )}
                    {values.cliente &&
                      (isSudo() ||
                        isAdmin() ||
                        isAprovador() ||
                        isSolicitante()) &&
                      values.cliente.possuiPontoAtendimento && (
                        <div className="form-group col-md-6">
                          <FormSelectInput
                            key={values.cliente.codigoCliente}
                            name="pontoAtendimentoId"
                            id="pontoAtendimentoId"
                            label="Ponto de Atendimento"
                            placeholder="Selecione o PA"
                            valueKey="id"
                            labelKey="nome"
                            required={true}
                            returnFullObject={false}
                            parent={values.cliente}
                            service={pontoAtendimentoService.findAllByCliente}
                            onChange={(name, value) => {
                              setFieldValue(name, value);
                            }}
                            value={values.pontoAtendimentoId}
                            messageValidate={errors.pontoAtendimentoId}
                            disabled={isFinalizado}
                          />
                        </div>
                      )}
                    {/* //dados que pertencem a clientes com PA */}
                    {values.cliente && (
                      <div className="row col-12">
                        <div className="form-group col-3 col-lg-3">
                          {!this.state.viewMode && (
                            <SelectInput
                              name="tipoPedido"
                              id="tipoPedido"
                              label="Tipo de pedido"
                              placeholder="Selecione o Tipo de pedido"
                              valueKey="value"
                              labelKey="label"
                              required={true}
                              returnFullObject={false}
                              defaultValue={values.tipoPedido}
                              options={objectsConstants.TIPO_PEDIDO}
                              onChange={(name, value) => {
                                setFieldValue(name, value);

                                const gruposValidos =
                                  value === 'MAPA'
                                    ? objectsConstants.GRUPO_PEDIDO_MAPA
                                    : objectsConstants.GRUPO_PEDIDO_AVULSO;

                                const grupoAtualValido = (
                                  gruposValidos || []
                                ).some((item) => {
                                  return item.value === values.grupoPedido;
                                });

                                if (!grupoAtualValido) {
                                  setFieldValue(
                                    'grupoPedido',
                                    value === 'MAPA' ? 'ALMOXARIFADO' : null,
                                  );
                                }
                              }}
                              value={values.tipoPedido}
                              disabled={isFinalizado}
                              messageValidate={errors.tipoPedido}
                            />
                          )}
                        </div>

                        <div className="form-group col-3 col-lg-3">
                          {!this.state.viewMode && (
                            <SelectInput
                              name="grupoPedido"
                              id="grupoPedido"
                              label="Grupo do Pedido"
                              placeholder="Selecione o grupo"
                              valueKey="value"
                              labelKey="label"
                              required={true}
                              returnFullObject={false}
                              isMulti={false}
                              searchable={false}
                              allowSelectAll={false}
                              options={
                                values.tipoPedido === 'MAPA'
                                  ? objectsConstants.GRUPO_PEDIDO_MAPA
                                  : objectsConstants.GRUPO_PEDIDO_AVULSO
                              }
                              onChange={(name, value) => {
                                setFieldValue(name, value);
                              }}
                              value={values.grupoPedido}
                              disabled={isFinalizado || !values.tipoPedido}
                              messageValidate={errors.grupoPedido}
                            />
                          )}
                        </div>
                        {(values.grupoPedido === 'JUDICIAL' ||
                          values.grupoPedido === 'DOMICILIAR') && (
                          <>
                            <div className="form-group col-3 col-lg-5">
                              {!this.state.viewMode && (
                                <FormInput
                                  name="nomePaciente"
                                  id={'nomePaciente'}
                                  label="Nome do paciente"
                                  placeholder="Nome do paciente"
                                  noSize={true}
                                  required={true}
                                  returnFullObject={true}
                                  isMulti={false}
                                  searchable={false}
                                  allowSelectAll={false}
                                  onChange={setFieldValue}
                                  value={values.nomePaciente}
                                  disabled={isFinalizado}
                                  messageValidate={errors.nomePaciente}
                                />
                              )}
                            </div>
                            <div className="form-group col-3 col-lg-4">
                              {!this.state.viewMode && (
                                <CpfInput
                                  name="cpfPaciente"
                                  id={'cpfPaciente'}
                                  label="CPF do paciente"
                                  placeholder="CPF do paciente"
                                  noSize={true}
                                  returnFullObject={true}
                                  isMulti={false}
                                  searchable={false}
                                  allowSelectAll={false}
                                  onChange={setFieldValue}
                                  value={values.cpfPaciente}
                                  disabled={isFinalizado}
                                  erroMensagem={
                                    typeof errors.cpfPaciente === 'string'
                                      ? errors.cpfPaciente
                                      : undefined
                                  }
                                  required={true}
                                />
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    )}
                    {/* Fim dados pertemcem clientes com PA */}
                    <div className="row col-12">
                      <div className="form-group col-3 col-lg-3">
                        {!this.state.viewMode && (
                          <FormInput
                            name="numeroPedidoCliente"
                            id={'numeroPedidoCliente'}
                            label="Número do pedido (Cliente)"
                            placeholder="Número pedido"
                            noSize={true}
                            required={false}
                            returnFullObject={true}
                            isMulti={false}
                            searchable={false}
                            allowSelectAll={false}
                            onChange={setFieldValue}
                            value={values.numeroPedidoCliente}
                            disabled={isFinalizado}
                          />
                        )}
                      </div>
                      <div className="form-group col-3 col-lg-3">
                        {!this.state.viewMode && (
                          <FormInput
                            name="transportadora"
                            id={'transportadora'}
                            label="Transportadora"
                            placeholder="Transportadora"
                            noSize={true}
                            required={false}
                            returnFullObject={true}
                            isMulti={false}
                            searchable={false}
                            allowSelectAll={false}
                            onChange={setFieldValue}
                            value={values.transportadora}
                            disabled={isFinalizado}
                          />
                        )}
                      </div>
                      {/* <div className="form-group col-3 col-lg-3">
                        {!this.state.viewMode && (
                          <DateTimePicker
                            name="dataHoraColeta"
                            id={'dataHoraColeta'}
                            label="Data e Hora da Coleta"
                            placeholder="Data e Hora da Coleta"
                            erroMensagem={errors.dataHoraColeta}
                            onChange={setFieldValue}
                            value={values.dataHoraColeta}
                            disabled={isFinalizado}
                            required={true}
                          />
                        )}
                      </div> */}
                      <div className="form-group col-1 col-lg-1 text-center">
                        <React.Fragment>
                          <div>
                            <label className="label-nowrap">Urgente:</label>
                            <div>
                              {!this.state.viewMode && (
                                <Switch
                                  onChange={(value) =>
                                    setFieldValue('urgente', value)
                                  }
                                  checked={values.urgente}
                                  onColor={'#0080ff'}
                                  offColor={'#d9d9d9'}
                                  height={30}
                                  width={60}
                                  handleDiameter={28}
                                  uncheckedIcon={false}
                                  checkedIcon={false}
                                  activeBoxShadow={'none'}
                                  disabled={isFinalizado}
                                />
                              )}
                            </div>
                          </div>
                        </React.Fragment>
                      </div>
                    </div>
                  </div>

                  {/* <div className="form-row">
                    {(isSudo() || isAdmin() || isAprovador()) && entity.id && (
                      <div className="form-group col-md-6">
                        <SelectInput
                          name="status"
                          id="status"
                          label="Status"
                          placeholder="Selecione o novo status"
                          valueKey="value"
                          labelKey="label"
                          noSize={true}
                          returnFullObject={false}
                          isMulti={false}
                          searchable={false}
                          allowSelectAll={false}
                          options={objectsConstants.STATUS_PEDIDO_DEVOLUCAO}
                          messageValidate={errors.status}
                          disabled={isFinalizado}
                          value={values.status}
                          className={`select-status ${values.status &&
                            values.status.toLowerCase()}`}
                          onChange={(name, value) => {
                            const statusAnterior = values.status;
                            const statusNovo = value;
                            const finalizando =
                              statusAnterior === 'CRIADO' &&
                              (statusNovo === 'APROVADO' ||
                                statusNovo === 'RECUSADO');

                            if (finalizando) {
                              confirmAlert({
                                customUI: ({ onClose }) => (
                                  <div className="custom-confirm-alert">
                                    <h2>Confirmação</h2>
                                    <p>
                                      Ao aprovar ou recusar, o pedido não poderá
                                      mais ser alterado. Deseja continuar?
                                    </p>
                                    <div className="d-flex justify-content-around mt-4">
                                      <button
                                        className="btn btn-secondary btn30 white"
                                        onClick={onClose}
                                      >
                                        Cancelar
                                      </button>
                                      <button
                                        className="btn btn-danger btn30"
                                        onClick={() => {
                                          setFieldValue(name, value);
                                          onClose();
                                        }}
                                      >
                                        Confirmar
                                      </button>
                                    </div>
                                  </div>
                                ),
                              });
                            } else {
                              setFieldValue(name, value);
                            }
                          }}
                        />
                      </div>
                    )}
                    {values.status === 'RECUSADO' && (
                      <div className="form-group col-md-12">
                        <label htmlFor="justificativaRecusa">
                          Justificativa da Recusa
                        </label>
                        <textarea
                          className="form-control"
                          name="justificativaRecusa"
                          id="justificativaRecusa"
                          rows="3"
                          value={values.justificativaRecusa}
                          onChange={handleChange}
                          disabled={isFinalizado}
                        />
                      </div>
                    )}
                  </div> */}
                  {!entity.id && (
                    <div className="form-group">
                      <label>Importar Arquivo CSV: </label>
                      <input
                        type="file"
                        accept=".csv"
                        onChange={(e) => this.handleCSVUpload(e, setFieldValue)}
                      />
                      {errors.produtos &&
                      typeof errors.produtos === 'string' ? (
                        <div className="text-danger">{errors.produtos}</div>
                      ) : null}
                    </div>
                  )}

                  {values.produtos && values.produtos.length > 0 && (
                    <div className="mt-4">
                      <table className="table table-bordered table-sm">
                        <thead>
                          <tr>
                            <th>Código</th>
                            <th>Produto</th>
                            {!isFinalizado && <th>Estoque Total</th>}
                            <th>Quantidade</th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.produtos.map((item, index) => (
                            <tr key={index}>
                              <td
                                className={
                                  item.estoqueTotal === 0
                                    ? 'text-danger font-weight-bold'
                                    : ''
                                }
                              >
                                {item.codigoProduto}
                              </td>
                              <td
                                className={
                                  item.estoqueTotal === 0
                                    ? 'text-danger font-weight-bold'
                                    : ''
                                }
                              >
                                {item.descricao}
                                {item.estoqueTotal === 0 && (
                                  <span className="text-red">
                                    {' '}
                                    (Sem estoque)
                                  </span>
                                )}
                              </td>
                              {!isFinalizado && <td>{item.estoqueTotal}</td>}
                              <td>
                                <FormInput
                                  type="number"
                                  noSize
                                  id={`produtos${index}qtdSolicitar`}
                                  erroMensagem={_.get(
                                    errors,
                                    `produtos[${index}].qtdSolicitar`,
                                  )}
                                  name={`produtos[${index}].qtdSolicitar`}
                                  value={item.qtdSolicitar}
                                  onChange={setFieldValue}
                                  disabled={
                                    isFinalizado ||
                                    (item.produto && item.produto.bloqueado) ||
                                    item.estoqueTotal === 0
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                  <div className="d-flex justify-content-end">
                    <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                      <button
                        type="button"
                        className="btn btn-secondary btn30 white"
                        disabled={isSubmitting}
                        onClick={() => this.props.history.goBack()}
                      >
                        Cancelar
                      </button>
                    </div>
                    <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                      <button
                        type="submit"
                        className="btn btn-secondary btn30 green"
                        disabled={isFinalizado || values.produtos.length === 0}
                      >
                        Salvar Pedido Importado
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapDispatch({ alert: { success, error }, load: { loading } }) {
  return {
    success: (msg) => success(msg),
    error: (msg) => error(msg),
    loading: (v) => loading({ load: v }),
  };
}

export default connect(
  null,
  mapDispatch,
)(ImportarPedidoEdit);
